import React from 'react';
import { Link, useLocation } from 'react-router-dom'
import './ArticleCardFixed.css';
import 'aos/dist/aos.css';
import CardTag from './CardTag';
import { BASE_URL } from '../constants';
import { postfixImageWidth, stringToUrl } from '../util';

const ArticleCardFixed = ({post, onClick, white}) => {
    // console.log(post);
    // console.log("Article Card");
    // console.log(typeof post.date)

    const date = new Date(post.date)
    const formattedDate = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    });

    const handleClick = () => {
        onClick(stringToUrl(post.title)); // Pass the _id to the onClick function
    };

  return (
    <div className='container' onClick={handleClick} data-aos="fade-up">
    <Link to={`/blog/post/${stringToUrl(post.title)}`} className='blog-link'>
        <div className='article-card-fixed' style={white ? {color: 'white'} : {color: 'black'}}>
            <div className='article-card-fixed_image-box'>
                <img src={`${BASE_URL}${postfixImageWidth(post.thumbnail, "800")}`} className="article-card-fixed_image" alt="article image"/>
            </div>
            <div className="card-body-fixed">
                <h5 className="article-card-fixed_date">{formattedDate}</h5>
                <h5 className="article-card-fixed_title">{post.title}</h5>
                <hr/>
                <p className="article-card-fixed_text">{post.subtitle}</p>
                <CardTag category={post.category}/>
            </div>
        </div>
    </Link>
    </div>
  )
}

export default ArticleCardFixed